module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.parkOffersIncubation) ? _c('ItemsQuestion', {
    ref: "child",
    attrs: {
      "question": _vm.question,
      "answer": _vm.answer,
      "isDisabled": _vm.isDisabled
    },
    on: {
      "answerUpdated": _vm.onAnswerUpdated
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa061208","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/quizzes/questions/IncubationProgramItemsQuestion.vue
// module id = 718
// module chunks = 1